import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { BehaviorSubject, Observable } from 'rxjs'
import { tap } from 'rxjs/operators'
import { jwtDecode } from 'jwt-decode'
import { AuthenticationResult } from '@azure/msal-browser'
import mappingGroup from 'src/app/features/settings/MappingGroups.json'

export interface MappingGroup {
  id: string
  name: string
  role: string
}

@Injectable({
  providedIn: 'root',
})
export class AzureService {
  private currentUserSubject = new BehaviorSubject<any>(null)
  authServiceInstance: any
  token = new BehaviorSubject<any>(null)
  rolesSubject = new BehaviorSubject<any>([]);
  selectedRole = new BehaviorSubject<string>('')
  selectedBusinessArea = new BehaviorSubject<string>('')


  constructor(private http: HttpClient) {
  }

  getUserInfo(): Observable<any> {
    const url = 'https://graph.microsoft.com/v1.0/me'
    return this.http.get(url).pipe(
      tap((userData) => {
        this.currentUserSubject.next(userData)
      })
    )
  }

  getCurrentUser(): Observable<any> {
    return this.currentUserSubject.asObservable()
  }

  getCurrentUserValue(): any {
    return this.currentUserSubject.value
  }

  setAuthServiceInstance(authService: any) {
    this.authServiceInstance = authService
  }

  getAuthServiceInstance() {
    return this.authServiceInstance
  }

  async getAccessToken(): Promise<any> {
    if (!this.authServiceInstance) {
      throw new Error('Auth service instance is not set.')
    }

    try {
      const tokenResponse: AuthenticationResult = await this.authServiceInstance
        .acquireTokenSilent({
          scopes: [
            `${this.authServiceInstance.instance.controller.config.auth.clientId}/.default`,
          ],
        })
        .toPromise()

      if (tokenResponse) {
        const idTokenDecoded = jwtDecode(tokenResponse.idToken)
        return {
          accessToken: tokenResponse.accessToken,
          idToken: tokenResponse.idToken,
          idTokenDecoded: idTokenDecoded,
          groupIds: [...new Set((tokenResponse.idTokenClaims as any).groups)],
        }
      }
    } catch (error) {
      console.error('Error fetching Token:', error)
      throw error
    }
  }

  logout() {
    this.authServiceInstance.logoutRedirect({
      postLogoutRedirectUri: '/',
    })
    this.authServiceInstance = null
    this.currentUserSubject.next(null)
    localStorage.removeItem('role')
  }

  async getRoles() {
    if (this.rolesSubject.value.length > 0) return this.rolesSubject.value
    if (this.token.value === null) {
      this.token.next(await this.getAccessToken())
    }
    const userGroup = this.token.value.groupIds
    const groups = mappingGroup.filter((group) =>{
      return userGroup.includes(group.id)
    })
    this.rolesSubject.next(groups);
    return groups;
  }


  getRolesObservable(): Observable<string> {
    return this.rolesSubject.asObservable();
  }

}
